import { render, staticRenderFns } from "./peopleAnJianTemple.vue?vue&type=template&id=54bb5828&scoped=true"
import script from "./peopleAnJianTemple.vue?vue&type=script&lang=js"
export * from "./peopleAnJianTemple.vue?vue&type=script&lang=js"
import style0 from "./peopleAnJianTemple.vue?vue&type=style&index=0&id=54bb5828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb5828",
  null
  
)

export default component.exports